import { ReactNode } from "react";
import {
  createBrowserRouter,
  Outlet,
  RouteObject,
  RouterProvider,
  matchPath,
} from "react-router-dom";
import { CAREER_PATH, CareerPage } from "@/modules/recruiting/pages/career";
import { Suspense } from "@/shared/suspense";
import { QueryParamProvider } from "@/application/providers/query-params-provider";
import { PublicLayout } from "@/application/layouts/public/public";
import {
  CAREER_VACANCY_PATH,
  CareerVacancyPage,
} from "@/modules/recruiting/pages/career-vacancy";

const routes: RouteObject = {
  element: (
    <QueryParamProvider>
      <PublicLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </PublicLayout>
    </QueryParamProvider>
  ),
  children: [
    {
      path: CAREER_PATH,
      element: <CareerPage />,
    },
    {
      path: CAREER_VACANCY_PATH,
      element: <CareerVacancyPage />,
    },
  ],
};
export function PublicRoutes({ children }: { children: ReactNode }) {
  const isPublic = routes.children?.find(
    (r) => !!matchPath(r.path as string, window.location.pathname),
  );

  if (isPublic) {
    return <RouterProvider router={createBrowserRouter([routes])} />;
  }

  return <>{children}</>;
}
